@if (showSpinner()) {
    <woa-spinner class="initiation-spinner"></woa-spinner>
}
@if (payFormError()) {
    <woa-content-message [level]="MessageLevel.ERROR" [text]="'woa.error.payment.paymentMethodUnavailable'"
                         [translationParams]="{cause: payFormError()}"></woa-content-message>
}
@if (paymentModel.paymentPlatformPublicKey() || submitted()) {
    <div id="tyro-card-pay-form-holder"></div>
}
@if (showSavePaymentDetailsOption() && !showSpinner()) {
    <woa-selector-control [label]="'woa.label.payment.saveCardDetails'"
                          [(selected)]="savePaymentDetails"></woa-selector-control>
}
